import React from 'react'

export default function Logo({size}) {
    return (
        <div className={size}>
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 348.000000 354.000000"
                preserveAspectRatio="xMidYMid meet">
                <metadata>
                Created by potrace 1.16, written by Peter Selinger 2001-2019
                </metadata>
                <g transform="translate(0.000000,354.000000) scale(0.100000,-0.100000)" fill="#2ADDA7" stroke="none">
                <path d="M1545 3440 c-116 -12 -315 -63 -415 -107 -126 -54 -303 -156 -374
                -213 -128 -105 -237 -216 -326 -335 -37 -49 -73 -102 -81 -116 -63 -118 -129
                -255 -129 -268 0 -14 2 -14 10 -1 12 18 12 2 0 -25 -5 -11 -9 -14 -9 -7 -1 7
                -6 10 -11 7 -8 -5 -7 -11 0 -20 7 -8 8 -20 4 -26 -5 -9 -9 -8 -14 5 -3 9 -6
                -7 -6 -36 -1 -29 -8 -73 -18 -98 -24 -66 -59 -316 -41 -298 3 3 10 45 15 94
                10 88 23 146 63 277 16 52 23 64 29 50 5 -10 5 -3 2 17 -6 30 -5 33 9 22 12
                -11 16 -8 22 15 8 35 56 133 73 151 6 7 12 20 12 27 0 12 22 46 118 186 75
                110 241 266 387 364 72 48 301 165 324 165 7 0 27 6 44 14 54 25 237 64 342
                74 98 9 321 2 400 -13 290 -53 584 -201 790 -396 28 -26 60 -55 72 -66 27 -22
                144 -180 195 -263 33 -53 118 -222 118 -234 0 -6 6 -23 14 -38 8 -15 17 -42
                21 -60 4 -18 15 -62 25 -98 79 -284 63 -613 -47 -940 -33 -98 -46 -126 -110
                -240 -49 -85 -75 -125 -151 -229 -30 -40 -20 -40 19 0 50 51 44 26 -11 -47
                -80 -107 -238 -246 -383 -338 -16 -10 -26 -20 -23 -23 11 -11 47 11 206 124
                95 68 255 239 338 361 26 39 130 241 157 307 48 115 98 296 110 396 4 30 9 65
                11 78 2 13 3 87 3 165 -1 218 0 238 5 244 17 16 21 -31 20 -241 0 -179 -4
                -247 -17 -297 -9 -36 -19 -85 -23 -110 -7 -51 -44 -175 -69 -235 -28 -69 -65
                -149 -75 -165 -5 -8 -17 -28 -26 -45 -51 -92 -160 -240 -234 -317 -47 -48 -77
                -85 -68 -82 10 3 18 3 18 -1 0 -9 -71 -75 -81 -75 -15 0 -10 13 14 35 34 30
                13 16 -88 -59 -49 -36 -95 -69 -101 -73 -48 -35 -285 -153 -306 -153 -10 0
                -18 -4 -18 -10 0 -5 -6 -7 -14 -4 -8 3 -17 1 -21 -5 -3 -6 -16 -11 -28 -11
                -18 0 -19 -2 -7 -11 11 -8 6 -9 -20 -4 -26 5 -31 4 -20 -4 12 -8 8 -11 -18
                -11 -22 0 -31 -4 -26 -12 5 -8 -5 -9 -37 -5 -29 4 -37 3 -24 -3 18 -8 17 -9
                -8 -9 -16 -1 -37 -6 -47 -11 -11 -6 -59 -15 -107 -20 l-88 -9 90 4 c186 8 489
                106 669 215 250 153 450 353 593 595 27 45 102 205 128 271 18 47 25 80 20 95
                -5 19 -4 21 5 9 8 -11 9 -6 4 23 -4 24 -2 37 5 37 6 0 8 7 5 15 -4 8 -2 21 3
                28 21 26 63 277 63 371 0 146 -54 446 -111 614 -45 135 -193 382 -289 483 -8
                8 -38 40 -66 70 -88 93 -227 208 -324 266 -102 61 -288 148 -353 164 -26 6
                -50 15 -53 20 -3 5 -15 9 -26 9 -30 0 -17 -10 44 -31 71 -25 6 -14 -74 12 -32
                10 -68 20 -80 20 -19 1 -18 3 7 10 22 6 15 7 -30 4 -33 -2 -50 -1 -37 2 12 2
                22 9 22 15 0 7 -17 8 -47 4 -29 -4 -43 -3 -35 2 29 20 -252 28 -403 12z"/>
                <path d="M2544 2900 c-113 -24 -365 -280 -655 -667 -46 -61 -91 -121 -99 -133
                -8 -13 -24 -35 -35 -49 -54 -68 -149 -210 -229 -341 -49 -80 -97 -157 -107
                -172 -11 -15 -19 -30 -19 -34 0 -3 -9 -17 -20 -31 l-19 -25 -7 27 c-9 35 3
                197 22 317 14 85 21 150 54 501 18 190 -9 357 -62 386 -24 14 -30 13 -63 -4
                -115 -63 -276 -334 -374 -635 -110 -334 -134 -801 -46 -889 30 -30 32 -16 6
                36 -11 21 -22 71 -26 113 -6 77 7 265 25 355 54 272 71 348 80 360 4 6 13 35
                20 65 7 30 16 60 20 65 4 6 11 21 15 35 19 62 94 208 157 304 52 79 141 166
                169 166 5 0 18 -9 29 -20 18 -18 20 -33 20 -172 0 -84 -7 -218 -15 -298 -9
                -80 -22 -212 -30 -295 -9 -82 -20 -170 -25 -195 -5 -25 -9 -86 -10 -136 0 -77
                3 -94 19 -108 15 -13 24 -15 39 -7 22 12 86 95 127 166 16 28 54 88 85 135 31
                47 70 106 86 131 86 133 319 450 417 569 218 262 420 438 491 428 23 -4 36
                -42 37 -113 1 -73 -19 -287 -36 -380 -8 -44 -21 -125 -30 -180 -44 -290 -85
                -499 -159 -810 -15 -60 -33 -137 -40 -170 -27 -118 -58 -240 -66 -260 -5 -11
                -15 -49 -24 -85 -8 -36 -24 -103 -36 -149 -13 -55 -17 -88 -11 -94 6 -6 12 0
                16 19 7 31 38 134 60 199 8 22 19 60 25 85 6 25 15 54 20 65 5 11 19 56 30
                100 11 44 30 114 41 155 20 71 31 117 81 320 53 219 137 705 159 925 6 55 9
                161 7 235 -4 176 -23 208 -114 190z"/>
                </g>
            </svg>

        </div>
    )
}
